module.exports = __webpack_public_path__ + "img/wawa.f11ae327.png";